import { gsap } from "gsap";

export default class FeaturedEvent {
    constructor(elm, carousel) {
        this.elm = elm;
        this.carousel = carousel;

        this.eventIndex = this.elm.getAttribute('data-featured-event');
        this.bullet = this.carousel.elm.querySelector('[data-bullet="' + this.eventIndex + '"]');

        this.front = this.elm.querySelectorAll('[data-front]');
        this.frontImages = [];
        this.front.forEach(front => {
            this.frontImages.push(front.querySelector('img'));
        });
        this.middle = this.elm.querySelectorAll('[data-middle]');
        this.middleImages = [];
        this.middle.forEach(middle => {
            this.middleImages.push(middle.querySelector('img'));
        });
        this.back = this.elm.querySelectorAll('[data-back]');

        this.title = this.elm.querySelector('[data-title]');
    }

    show() {
        this.elm.classList.add('c-featured-event--active');
        this.elm.setAttribute('data-index', this.carousel.featuredEvents.length * 1);
        this.setIndex(this.carousel.featuredEvents.length * 1);

        this.bullet.classList.add('swiper-pagination-bullet-active');

        this.showAnimation();
    }

    showAnimation() {

        const mm = gsap.matchMedia();

		mm.add({
				isMobile: "(max-width: 991px)",
				isDesktop: "(min-width: 992px)",
				reduceMotion: "(prefers-reduced-motion: reduce)",
			}, (context) => {
                let { isMobile, isDesktop, reduceMotion } = context.conditions

                const show = gsap.timeline({
                    onComplete: () => {
                        this.carousel.next();
                    },
                });

                show.to(this.front, {
                    opacity: 1,
                    duration: reduceMotion ? 4 : 0
                }, 0);

                if(!reduceMotion) {
                    show.fromTo(this.frontImages, {
                        x: '2.5%',
                        y: '-1.5%',
                        scale: 1.05,
                    }, {
                        x: '5%',
                        y: '-3%',
                        scale: 1.1,
                        duration: 0,
                        ease: 'expo.inOut'
                    }, 0);
                }

                show.to(this.title, {
                    opacity: 1,
                    duration: 0,
                }, 0);

                if(!reduceMotion) {
                    show.to(this.title, {
                        "clip-path": "polygon(-10% -10%, 110% -10%, 110% -1%, -10% -10%)",
                        translateY: '100%',
                        duration: 0,
                    }, 0);

                    show.to(this.middle, {
                        opacity: 1,
                        duration: 0,
                    }, 1);

                    show.to(this.back, {
                        opacity: 1,
                        duration: 0,
                    }, 0.6);

                    show.fromTo(this.middleImages, {
                        x: '-5%',
                        y: '3%',
                        scale: 1.1
                    }, {
                        x: '0',
                        y: '0',
                        scale: 1,
                        duration: 2.5,
                        ease: 'expo.inOut',
                    }, 1);

                    show.fromTo(this.frontImages, {
                        x: '5%',
                        y: '-3%',
                    }, {
                        x: '0',
                        y: '0',
                        scale: 1,
                        duration: 3.5,
                        ease: 'expo.inOut',
                    }, 1.5);
                    show.to(this.title, {
                        "clip-path": "polygon(-10% 110%, 110% 110%, 110% -10%, -10% -10%)",
                        translateY: '0%',
                        duration: 2.5,
                        ease: 'expo.inOut',
                    }, 1.5);
                }

			}
		);
    }

    hide() {
        this.bullet.classList.remove('swiper-pagination-bullet-active');

        const hide = gsap.timeline({
            onComplete: () => {
                this.elm.classList.remove('c-featured-event--active');
            },
        });

        hide.to(this.title, {
            opacity: 0,
            duration: 0
        }, 0);
        hide.to(this.front, {
            opacity: 0,
            duration: 0
        }, 0);

        hide.to(this.back, {
            opacity: 0,
            duration: 0
        }, 0.6);

        hide.to(this.middle, {
            opacity: 0,
            duration: 0
        }, 1);
    }

    updateIndex() {
        this.currentIndex = this.elm.getAttribute('data-index');
        this.elm.setAttribute('data-index', this.currentIndex - 1);
        this.setIndex(this.carousel.featuredEvents.length * 1);
    }

    setIndex() {
        const index = this.elm.getAttribute('data-index');
        this.elm.setAttribute('style', '--data-index: ' + index + ';');

        const bg = this.elm.getAttribute('data-bg');
        this.carousel.elm.setAttribute('style', '--data-bg: ' + bg + ';');
    }
}
